import React from 'react';
import {SVGModel} from '../../../framework.visual/model/svgModel';

export const ArrowUpSVG = ({className} : SVGModel) => (
    <svg className={className} viewBox="0 0 32 32">
        <path d="M 8,16 15.999999,8.0000002 24,16 32,24 H 15.999999 0 Z"/>
    </svg>
);


